import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
    selector: 'app-customsnackbar',
    templateUrl: './customsnackbar.component.html',
    styleUrls: ['./customsnackbar.component.css'],
    standalone: false,
})
export class CustomsnackbarComponent {
    constructor(public snackBarRef: MatSnackBarRef<CustomsnackbarComponent>, @Inject(MAT_SNACK_BAR_DATA) public data: any) {}
}
